export default "__VITE_ASSET__CPZkyT$k__"